define('Components/Comein/js/views/blocks/ComeinProfileAdvantagesView',['backbone','underscore','app','hooks',
    'TagCommander',
    'views/pages/account/AccountView',
    'Components/Comein/js/models/CagnotteModel',
    'models/AdvantageCollection',
    'models/AdvantageModel',
    'models/CustomerModel',
    'template!Components/Comein/templates/account/advantages',
    'template!Components/Comein/templates/blocks/advantage-line',
    'template!Components/Comein/templates/blocks/status-progress'
],function(
    Backbone,_,app,hooks,
    TagCommander,
    AccountView,
    CagnotteModel,
    AdvantageCollection,
    AdvantageModel,
    CustomerModel,
    advantagesTemplate,
    advantageLineTemplate,
    statusProgressTemplate

){

    var _FILTERS_ID_ = ['current','available_now_account','next_strict'],
        _FILTERS_NAME_ = ['les avantages du statut %s','mes avantages disponibles','au prochain statut %s'],
        _FILTERS_EMPTY_ = [
            'Aucun avantage n\'est disponible',
            'Aucun avantage n\'est disponible',
            'Aucun avantage n\'est disponible'
        ],
        _FILTERS_;

   return AccountView.extend({
       events:{
            'click .account-cagnotte__history > .link':'displayLoyaltyHistoryModal',
            'click .account-advantage__filter':'clickFilter',
       },


       initialize:function(){
           console.log('initialize Loyalty Comein profile view');
            var view = this,
                model = view.model = new CagnotteModel();

           view.status =  model.getStatusActive();
           view.amountCagnotte = model.getAmount();
           view.amountCagnotteFormat = model.formatAmount({wrap_sup:true,auto_round_decimal:true});
           view.isCagnotteExpire = model.isExpire();
           view.formatExpirationDate  = model.formatExpirationDate('LL');
           view.formatAmount = model.formatAmount();
           view.render();
           view.listenTo(app,'resize',view.resize);

       },
       clickFilter:function(e)
       {
           this.selectFilter($(e.currentTarget).data('filter'));
       },
       afterInitialize:function(){
           this.renderStatus();
       },
       selectFilter:function(filterType){
           var view = this;
           view.$('.account-advantage__filter').each(function(){
               var $this = $(this);
               $this.toggleClass('active',$this.data('filter')===filterType);
           });
           view.$('.account-advantage, .account-advantage__group').each(function(){
               var $this = $(this);
               $this.toggleClass('visible',$this.is('.filter-'+filterType));
           });
           // affiche le bloc pas de résultat
           view.$('.account-advantage__group--no-result').toggleClass('visible',view.$('.account-advantage__group.visible').length===0);

       },
        getActive:function () {
            var view = this;

            return view.getActive();
        },

       render:function(){
           var view = this,
               allPreviousAdvantages,
               customer = app.getCustomer(),
               customerSegmentCurrent = parseInt(customer.getSegment()),
               customerSegmentNext = customerSegmentCurrent+1;
           //
           if(!(customerSegmentCurrent>0)){
               customerSegmentCurrent = 0;
               customerSegmentNext = 1;
           }
           var statusList = CustomerModel.STATUS_LIST;
           statusList = _.map(statusList,function(statusName,index){
               var upperId = statusName.toUpperCase(),
                   lowerId = statusName.toLowerCase();
               return {
                   name: app.t(statusName, 'Account'),
                   // convert name to id
                   id:lowerId,
                   upperId:upperId,
                   // _ICHI_TEXT_ACCOUNT_
                   // _NI_TEXT_ACCOUNT_
                   // _SAN_TEXT_ACCOUNT_
                   description: app.c('_'+upperId+'_TEXT_ACCOUNT_'),
                   active: view.status == index+1
               };
           });

           function StatusValue(n,prop){
               prop = prop || 'name';
               return n == 0 ? '' : n > 3 ? '' : statusList[n-1][prop];
           }
           // instancie les filtres
           if(!_FILTERS_) {
               _FILTERS_ = _(_.map(_FILTERS_ID_, function (id, index) {
                   // sur le premier filtre
                   var statusLabel = StatusValue(index > 1 ? customerSegmentNext:customerSegmentCurrent);//statusList[(index > 1 ? customerSegmentNext:customerSegmentCurrent)-1].name;
                   console.log('customerSegmentCurrent',customerSegmentCurrent,customerSegmentNext,index,statusList);
                   return {
                       id: id,
                       label: app.t(_FILTERS_NAME_[index], 'Account', statusLabel),
                       empty_label: app.t(_FILTERS_EMPTY_[index], 'Account')
                   }
               }));
           }
           // permet de gérer un pseudo-avantage afin de l'afficher en premier dans la liste des avantages
           var statusCurrentLabel = StatusValue(customerSegmentCurrent),
               currentStatusIdUpper = StatusValue(customerSegmentCurrent,'upperId'),
               allPreviousDescription = app.c('_'+currentStatusIdUpper+'_ACCOUNT_NEXT_DESCRIPTION_',''),
               allPreviousName = app.t('Tous les avantages du statut %s','Account',statusCurrentLabel);
           if(customerSegmentCurrent >= 3){
               allPreviousName = app.t('Nous avons déjà le plaisir de vous compter parmi nos meilleurs clients !','Account');
           }
           allPreviousAdvantages = new AdvantageModel({
               name: allPreviousName,
               description: allPreviousDescription,
               next: true,
           });
           //
           var advantageGroups = app.getCustomer().getAdvantageGroups(),
                templateOptions = {
                   // status:view.status,
                   statusList:_(statusList),
                   customerSegmentCurrent: customerSegmentCurrent,
                   amountCagnotte:view.amountCagnotte,
                   advantageGroups:advantageGroups,
                   formatExpirationDate:view.formatExpirationDate,
                   formatAmount:view.formatAmount,
                   amountCagnotteFormat:view.amountCagnotteFormat,
                   isCagnotteExpire:view.isCagnotteExpire,
                   allPreviousAdvantages:allPreviousAdvantages,
                   filters:_FILTERS_,
               };

           view.$el.html(advantagesTemplate(templateOptions));

           //
           view.renderStatus();

           // affiche les avantages disponibles
           view.selectFilter('available_now_account');
       },

       resize:function(){
           this.renderStatus();
       },

       renderStatus:function(){

           var view = this,
               comeInHistory = view.$('.comein-history'),
               comeInHistoryWidth = comeInHistory.width();
           if(comeInHistoryWidth==0) return;
//
           //
           //
           function getPercent(val, scaleMin, scaleMax, scaleVal){
               var max = Math.max(scaleVal, scaleMax),
                   min = Math.min(scaleVal, scaleMin);
               return Math.sqrt(val - min) / Math.sqrt(max - min) * 90 + 5; // Marges de 5% sur les coté donc on calcule la valeur sur 90% et on ajoute 5% pour la marge de gauche
           }
           //
           function drawBarPath(width, height){
               var w = width, // 750
                   w10 = w - 10, // 740
                   w4 = w - 4; // 746
               // <path d="M750,10 C750,4 746,0 740,0 L7,12 C0,12 0,15 0,17 C0,19 0,22 7,22 L740,34 C746,34 750,30 750,24 L750,10 Z" id="Shape"></path>
               return 'M'+w+',10 C'+w+',4 '+w4+',0 '+w10+',0 L7,12 C0,12 0,15 0,17 C0,19 0,22 7,22 L'+w10+',34 C'+w4+',34 '+w+',30 '+w+',24 L'+w+',10 Z';
           }
           //
           function getStatus(id,name){
               var _COMEIN_STATUS_THRESHOLD_ = '_COMEIN_STATUS_THRESHOLD_',
                   _TYPE_ = id.toUpperCase()+'_',
                   isOrders = id === 'orders',
                   height=34,
                   minHeight = 10,
                   min = 1,
                   med = parseFloat(app.c(_COMEIN_STATUS_THRESHOLD_+_TYPE_+'NI_')),
                   max = parseFloat(app.c(_COMEIN_STATUS_THRESHOLD_+_TYPE_+'SAN_')),
                   val = parseFloat(app.getCustomer().getNeolaneParam(isOrders?'countOrderMonth12':'sumAmountMonth12',0)),
                   valp = getPercent(val,min,max,val),
                   cr = (minHeight+(height-minHeight)*(valp/100))/2,// circle radius
                   status = {
                       id:id,
                       name:app.t(name,'Account'),
                       currency: app.getCurrency().getSign(),
                       min:min,
                       med:med,
                       max:max,
                       val:val,
                       color:isOrders?'#ffffff':'#b4a895',
                       width:comeInHistoryWidth,
                       height:height,
                       path:drawBarPath(comeInHistoryWidth),
                       pathp:drawBarPath(comeInHistoryWidth*valp/100 - cr),
                       minp:getPercent(min,min,max,val),
                       medp:getPercent(med,min,max,val),
                       maxp:getPercent(max,min,max,val),
                       minsup:min>val,
                       medsup:med>val,
                       maxsup:max>val,
                       valp:valp,
                       cr:cr
                   }
               ;
               return status;
           }
           //
           var ordersStatus = getStatus('orders','Commande'),
               amountsStatus = getStatus('amounts','Montant');
           //
           comeInHistory.html(
               statusProgressTemplate(ordersStatus)+
               statusProgressTemplate(amountsStatus)
           );


       },

       displayLoyaltyHistoryModal:function(e){
            //
           TagCommander.eventGA(e.currentTarget,"compte","historique cagnotte");
           hooks.execHook('LoyaltyHistoryView',null,function(LoyaltyHistoryView){
               var loyaltyView = new LoyaltyHistoryView();
               app.displayModal(loyaltyView);
           });
       },
       autoadddiscount:function(event)
       {

           var view = this,
               vouchercode = view.$(event.currentTarget).data('vouchercode');
           app.getCart().addVoucher(vouchercode);
       },
   });
});
